module.exports = "<div class=\"commandItem\" (click)=\"onSelected.emit(item)\">\n    <div>{{setSpace()}}</div>\n</div>\n<hr class=\"lineForList\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/environmentDetails/automation/command-item/command-item.component.html
// module id = 1733
// module chunks = 0